export default __webpack_public_path__ + "static/media/defaultAvatar.fbec612e.jpg";